import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ22_V4T: TStep[] = [
  {
    pageId: PageId.SEX_22V4T,
  },
  {
    pageId: PageId.DOG_AGE_22V4T,
  },
  {
    pageId: PageId.DOG_BREED_22V4T,
  },
  {
    pageId: PageId.URGE_22V4T,
  },
  {
    pageId: PageId.COMMANDS_61_22V4T,
  },
  {
    pageId: PageId.COMMANDS_62_22V4T,
  },
  {
    pageId: PageId.COMMANDS_63_22V4T,
  },
  {
    pageId: PageId.URGE_2_22V4T,
  },
  {
    pageId: PageId.POTTY_22V4T,
  },
  {
    pageId: PageId.BEHAVIOR_22V4T,
  },
  {
    pageId: PageId.TRAINING_22V4T,
  },
  {
    pageId: PageId.PREPARE_FLOW_22V4T,
  },
  {
    pageId: PageId.DOG_STATISTICS_22V4T,
  },
  {
    pageId: PageId.EMAIL_22V4T,
  },
  {
    pageId: PageId.NEWSLETTER_URGE_22V4T,
  },
  {
    pageId: PageId.LAST_CHANCE_OFFER_22V4T,
  },
  {
    pageId: PageId.SUBSCRIPTIONS_22V4T,
  },
  {
    pageId: PageId.CANCEL_OFFER_22V4T,
  },
  {
    pageId: PageId.CHAT_UPSELL_22V4T,
  },
  {
    pageId: PageId.UPSELL_22V4T,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
  {
    pageId: PageId.DOWNLOAD_22V4T,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V4T.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ22_V4T.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
